function check(password?: string) {
  if (!password) return false
  return /\d/.test(password)
}

export default {
  check,
}
